import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from "react-i18next";
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TwitterIcon from '@mui/icons-material/Twitter';
import SvgIcon from '@mui/material/SvgIcon';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import euLogo from '../images/EuLogoTransparent.png';
import rtrLogo from '../images/Logo_Plan_RTR.png';
import { useNavigate } from "react-router-dom";
import { useUser } from '../hooks/useUser';

const Footer = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const [urls, setUrls] = useState()

    const { getURLs } = useUser()

    useEffect(() => {
        getURLs()
            .then((data) => {
                setUrls(data.links)
            })
    }, [])

    return (
        <>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{
                    bgcolor: 'primary.main', // Theme Component
                    padding: '1em'
                }}
            >
                <Box>
                    <Typography variant="caption" target="_blank" color="text.link" >
                        {t('footer.teGusta')}
                        <Link href={urls?.contacto} color="text.link" target="_blank">{t('footer.tuOpinion')}</Link>
                    </Typography>
                </Box>
                <Box>
                    <Grid
                        container
                        direction="row"
                        spacing={2}
                    >
                        <Grid
                            item
                            display="flex"
                            justifyContent="space-evenly"
                            alignItems="center"
                            flexWrap={"wrap"}
                            columnGap={4}
                            rowGap={2}

                        >
                            <img src={rtrLogo} alt="reu" />
                            <img src={euLogo} alt="eu" />
                            <Box>
                                <IconButton color="text" href={urls?.twitter} target="_blank">
                                    <SvgIcon>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="21.5" viewBox="0 0 26 26">

                                            <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 8.6484375 9 L 13.259766 9 L 15.951172 12.847656 L 19.28125 9 L 20.732422 9 L 16.603516 13.78125 L 21.654297 21 L 17.042969 21 L 14.056641 16.730469 L 10.369141 21 L 8.8945312 21 L 13.400391 15.794922 L 8.6484375 9 z M 10.878906 10.183594 L 17.632812 19.810547 L 19.421875 19.810547 L 12.666016 10.183594 L 10.878906 10.183594 z" />
                                        </svg>
                                    </SvgIcon>
                                </IconButton>
                                <IconButton color="text" href={urls?.facebook} target="_blank">
                                    <FacebookIcon />
                                </IconButton>
                                <IconButton color="text" href={urls?.youtube} target="_blank">
                                    <YouTubeIcon />
                                </IconButton>
                                <IconButton color="text" href={urls?.linkedin} target="_blank">
                                    <LinkedInIcon />
                                </IconButton>
                                <IconButton color="text" href={urls?.rss} target="_blank">
                                    <RssFeedIcon />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Stack style={{ textAlign: 'center' }}>
                    <Typography variant="caption" color="text.link">
                        <Link href={urls?.dgipyme} target="_blank" color="text.link">{t("footer.direccionGeneral")}</Link>
                    </Typography>
                </Stack>
            </Stack>
        </>
    );
};
export default Footer;

